export enum BesprechungChannelTypes {
  streaming,
  tv,
  mediathek
}
